<template>
	<div :class="{ 'is-error': isError }" class="container">
		<NotFoundContent v-if="isError" />
		<LoadingSpinner v-else-if="isLoading" />
		<div v-else-if="groupInfo">
			<Breadcrumbs v-if="!isSmallDevice" :items="breadcrumb" />
			<h1 v-html="title" />
			<div
				v-if="isSmallDevice && isShowListTitle"
				:style="[
					{ backgroundColor: groupInfo.color },
					{ top: `${scrollOffset}px` },
				]"
				class="list-title"
			>
				{{ groupInfo.name }}
			</div>
			<ul ref="list" class="list">
				<li
					v-for="(item, itemIndex) in items"
					:key="item.name"
					class="item"
				>
					<div ref="card" class="card">
						<div
							:style="{ backgroundColor: itemColor(item) }"
							class="top-border"
						/>
						<div
							v-if="!isSmallDevice"
							class="top"
							@click="onHeadingClick(item)"
						>
							{{ groupInfo.name }}
						</div>
						<ul class="levels">
							<template
								v-for="(subItem, subItemIndex) in subItems(
									item
								)"
							>
								<li :key="subItem.name">
									<router-link
										:to="subItemLink(item, subItem)"
										class="link"
									>
										<span
											class="text-wrapper"
											@click="handleClick(subItem)"
											v-html="subItemTitle(subItem)"
										/>
									</router-link>
								</li>
								<li
									v-if="
										isSmallDevice &&
											getLevelAd(itemIndex, subItemIndex)
									"
									:key="`advertising-${subItem.name}`"
									class="advertising-container"
								>
									<Advertising
										:stub="
											getLevelAd(itemIndex, subItemIndex)
										"
									/>
								</li>
							</template>
						</ul>
					</div>
					<div v-if="item.ad" class="advertising-container">
						<Advertising
							:stub="item.ad.stub"
							:placement="item.ad.placement"
						/>
					</div>
				</li>
			</ul>
		</div>
		<aside v-if="!isError && !isSmallDevice" class="sidebar">
			<Advertising
				:stub="AD_LAYOUT_STUBS.RIGHT_RAIL"
				:style="{ top: `${topElementsHeight + 25}px` }"
				class="advertising--sticky"
			/>
		</aside>
	</div>
</template>

<script>
import { AD_LAYOUT_STUBS } from "@/common/consts";
const Advertising = () =>
	import(
		/* webpackChunkName: "component-advertising" */ "@/components/advertising"
	);
const Breadcrumbs = () =>
	import(
		/* webpackChunkName: "component-breadcrumbs" */ "@/components/breadcrumbs"
	);
const LoadingSpinner = () =>
	import(
		/* webpackChunkName: "component-loading-spinner" */ "@/components/loading-spinner"
	);
import NotFoundContent from "@/pages/not-found/content.vue";

import computed from "./computed";
import methods from "./methods";
import metaInfo from "./meta";

export default {
	name: "GroupPage",
	components: {
		Advertising,
		Breadcrumbs,
		LoadingSpinner,
		NotFoundContent,
	},
	data: function() {
		return {
			AD_LAYOUT_STUBS,
			levelsPerAd: 3,
			ads: [AD_LAYOUT_STUBS.MOB_IN_CONTENT],
			groupInfo: null,
			packs: [],
			isLoading: false,
			isError: false,
		};
	},
	computed,
	watch: {
		$route: "refreshPage", // call again the method if the route changes
	},
	mounted: function() {
		this.refreshPage();
	},
	methods,
	metaInfo,
};
</script>

<style lang="scss" src="./styles.scss" scoped></style>
